import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import h from "../../helpers";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import LoadingTable from "../material-components/WidgetSkeleton/LoadingTable";
import TableHeader from "../material-components/Table/TableHeader";
import TableBody from "../material-components/Table/TableBody";

const FlowFieldsUsed = ({ workflowId, companyId, flowItemId }) => {
    const [usedFields, setUsedFields] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if ((workflowId, companyId, flowItemId)) {
            getTableData();
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workflowId, companyId, flowItemId]);

    const getTableData = () => {
        setIsLoading(true);

        const fields = [];
        if (companyId && flowItemId) {
            const url = `/Flows/UsedFields?flowItemId=${flowItemId}&companyId=${companyId}`;
            fetch(url, { credentials: "same-origin" })
                .then(h.checkStatus)
                .then(h.toJson)
                .then(data => {
                    if (data && data.usedFields) {
                        Object.entries(data.usedFields).forEach(field => {
                            fields.push({
                                Name: field[0],
                                Values: field[1],
                            });
                        });
                    }
                    setUsedFields(fields);
                    setIsLoading(false);
                })
                .catch(error => {
                    h.error("Error loading used fields.", error);
                    setUsedFields(fields);
                    setIsLoading(false);
                });
        } else {
            h.error("Error loading used fields.");
            setUsedFields(fields);
            setIsLoading(false);
        }
    };

    if (!workflowId) {
        return (
            <div>
                <strong>Data unavailable</strong>
            </div>
        );
    } else {
        const tableHeaders = [
            ["Name", "Name", "smDown"],
            ["Values", "Values", "smDown", "center"],
        ];
        const emptyMessage = ["EmptyMessage", "No fields to display.", "smDown"];

        let tableData = [];
        if (usedFields) {
            usedFields.forEach((item, index) => {
                tableData.push([
                    ["Name", item.Name, "smDown"],
                    [
                        "Values",
                        <div key={item + "-" + index} style={{ whiteSpace: "normal" }}>
                            {item.Values}
                        </div>,
                        "smDown",
                    ],
                ]);
            });
        }

        return (
            <div className="dataTables_wrapper" id="myTable">
                <Paper style={{ maxHeight: "300px", width: "600px", overflow: "auto" }}>
                    <Table stickyHeader style={{ marginTop: 0 }}>
                        <TableHeader headers={tableHeaders} ignoreHeaders={tableHeaders} />
                        {isLoading ? (
                            <LoadingTable cols={2} rows={5} />
                        ) : (
                            <TableBody
                                data={tableData}
                                page={0}
                                rowsPerPage={tableData.length}
                                emptyMessage={emptyMessage}
                            />
                        )}
                    </Table>
                </Paper>
            </div>
        );
    }
};

FlowFieldsUsed.propTypes = {
    // Passed In
    workflowId: PropTypes.number,
    companyId: PropTypes.number,
    flowItemId: PropTypes.number,
};

export default FlowFieldsUsed;
